import {CurrentUtils} from "xmgoing-server";

export const handleGlobalClick = function () {
  const editorShowPanel = document.getElementById('editorShowPanel');
  if (editorShowPanel) {
    editorShowPanel.remove();
  }
};


export function useWatermarkHooks() {

  const model = reactive({
    content: '普通游客',
    layout: 'alternate',
    color: 'rgba(0,0,0,.15)',
    fontSize: 12,
    fontWeight: 340,
    zIndex: 9,
    rotate: -22,
    gap: [100, 100],
    offset: [50, 50]
  })

  CurrentUtils._loadUser(false, (user) => {
    model.content = user.realName || user.phone || '星芒平台';
  })


  onMounted(() => {
    document.addEventListener('click', handleGlobalClick);
  });

  return {
    model
  }
}
